module.exports = __webpack_public_path__ + "media/images/xl_code-4a459789ef66deb7b0b785c99b50b279.png";